<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <b-card-title>Applying spacing with components</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  <b-img
                    src="@/assets/images/pages/spacing-example-simple.png"
                    fluid
                    width="550px"
                  />
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>

          <b-card-header>
            <b-card-title>How to choose spacing</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  <p>Use less space between small components, or components that share a close functional relationship.</p>
                  <b-img
                    src="@/assets/images/pages/spacing-example-simple-details-1.png"
                    fluid
                    class="pb-1"
                    width="550px"
                  />
                  <p>Coordinate small and large values, along with structural components (like Home cards), to create visual groupings of related things. This helps merchants understand the interface and more easily find what they’re looking for. For screens with specialized layouts, adjust overall spacing based on the density of the content. For example, a simple login screen on desktop display has more room to breathe, so more space can be used.</p>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>

          <b-card-header>
            <b-card-title>Common values</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  <p>The most common spacing sizes are used throughtout EasyParcel as follows.</p>
                  <b-img
                    src="@/assets/images/pages/spacing-example-simple-details-2.png"
                    fluid
                    class="pb-25"
                  />
                  <p>4px between label and input.</p>
                  <b-img
                    src="@/assets/images/pages/spacing-example-simple-details-3.png"
                    fluid
                    class="pb-25"
                  />
                  <p>8px between icon and text.</p>
                  <b-img
                    src="@/assets/images/pages/spacing-example-simple-details-4.png"
                    fluid
                    class="pb-25"
                  />
                  <p>16px generally used between components in same family, such as: text and related buttons, in between of form input, etc.</p>
                  <b-img
                    src="@/assets/images/pages/spacing-example-simple-details-5.png"
                    fluid
                    class="pb-25"
                  />
                  <p>20px padding in card, card header, card title, and generally used between components group.</p>
                  <b-img
                    src="@/assets/images/pages/spacing-example-simple-details-6.png"
                    fluid
                    class="pb-25"
                  />
                  <p>24px between cards.</p>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>

          <b-card-header>
            <b-card-title>Adjustments and exceptions</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  <p>In cases where minor alignment adjustments are necessary, some exceptions apply:</p>
                  <p>Allow the length of text to determine the width of components and where they fall horizontally when placed in a row.</p>
                  <h5>Optical adjustment</h5>
                  <p>Sometimes an element is larger or smaller than it appears. Spacing based on the invisible edges of the element would feel wrong.<br>Correct for these optical effects by adjusting the space until it looks more balanced. Without optical adjustment, the disclosure icon appears too far from the right edge of the button. After optical correction, the perceived spacing is more balanced.</p>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardText,
    BImg,
  },
}
</script>
